import { render, staticRenderFns } from "./shopOwnerRecord.vue?vue&type=template&id=c5d80f1a&scoped=true&"
import script from "./shopOwnerRecord.vue?vue&type=script&lang=js&"
export * from "./shopOwnerRecord.vue?vue&type=script&lang=js&"
import style0 from "./shopOwnerRecord.vue?vue&type=style&index=0&id=c5d80f1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d80f1a",
  null
  
)

export default component.exports